// This mixin contains code that is used for contracts, services, service bundles and commercial configs
import { _ } from 'underscore';

export default {
  computed: {
    tenancies() {
      return this.$store.getters.allTenancies;
    },
    contracts() {
      return _.sortBy(
        this.$store.state.contracts.contracts,
        'StartDate'
      ).reverse();
    },
    activeSection: {
      get() {
        return this.$store.state.contracts.activeSection;
      },
      set(section) {
        this.$store.commit('updateActiveSection', section);
      },
    },
    breadcrumbItems: {
      get() {
        return this.$store.state.contracts.breadcrumbItems;
      },
      set(items) {
        this.$store.commit('updateBreadcrumbItems', items);
      },
    },
    activePSRSet: {
      get() {
        return this.$store.state.contracts.activePSRSet;
      },
      set(psrSet) {
        this.$store.commit('updateActivePSRSet', psrSet);
      },
    },
    activeBundle: {
      get() {
        return this.$store.state.contracts.activeBundle;
      },
      set(bundle) {
        this.$store.commit('updateActiveBundle', bundle);
      },
    },
    activeContract: {
      get() {
        return this.$store.state.contracts.activeContract;
      },
      set(contract) {
        this.$store.commit('updateActiveContract', contract);
      },
    },
    activeTenancy() {
      if (!this.activeService) return;

      return this.tenancies.find(
        (t) =>
          t.TenancySharedId ===
          this.activeService[`${this.activeServiceType}Details`].TenancySharedId
      );
    },
    activeService: {
      get() {
        return this.$store.state.contracts.activeService;
      },
      set(service) {
        this.$store.commit('updateActiveService', service);
      },
    },
    activeServiceType() {
      if (!this.activeService) return null;
      return this.$store.state.contracts.activeService.ServiceType;
    },
    activeCommercialConfig: {
      get() {
        return this.$store.state.contracts.activeCommercialConfig;
      },
      set(commercialConfig) {
        this.$store.commit('updateActiveCommercialConfig', commercialConfig);
      },
    },
  },
  methods: {
    navigateTo(section, route) {
      this.activeSection = section;
      if (!route) {
        return this.$store.commit('addBreadcrumbItems', [section]);
      }
      this.$store.commit('addBreadcrumbItems', route);
    },
  },
};
